import { arrayOf, bool, shape, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import RecipeIngredients from 'components/Recipe/RecipeIngredients';
import RecipeInstructions from 'components/Recipe/RecipeInstructions';
import RecipeSupplies from 'components/Recipe/RecipeSupplies';
import RecipeSupplyAffiliateLinkDataProvider from 'components/RecipeSupplyAffiliateLinkDataProvider';
import LazyLoad from 'components/LazyLoad';
import Chicory from 'components/Chicory';
import { HAS_INGREDIENT_ADDON } from 'constants/site';
import { isMobile } from 'util/viewport';
import useWindowSize from './helper';
import styles from './styles';

function RecipeFirstRecipe(props) {
  const { recipe, post } = props;
  const { ingredientGroups, instructionGroups, notes } = recipe;
  const [rightColumnHeight, setRightColumnHeight] = useState(undefined);
  const isMobileViewport = isMobile(1024);
  const viewPortWidth = useWindowSize();

  useEffect(() => {
    const leftHeight = document.querySelector('.RecipeFirstRecipe__leftColumn')
      .offsetHeight;
    const rightHeight = document.querySelector(
      '.RecipeFirstRecipe__rightColumn'
    ).offsetHeight;
    const chicoryHeight = 75; // chicory is loaded async so calculate approx height here

    if (viewPortWidth.width < 1024) {
      setRightColumnHeight(undefined);
    }
    if (rightHeight >= leftHeight && viewPortWidth.width >= 1024) {
      setRightColumnHeight(leftHeight + chicoryHeight);
    }
  }, [viewPortWidth, isMobileViewport]);

  const ingredientsAddOn =
    HAS_INGREDIENT_ADDON && post && !post.isSponsored ? (
      <LazyLoad height={0} offset={300} once>
        <Chicory canonical={post.canonical} />
      </LazyLoad>
    ) : null;

  return (
    <RecipeSupplyAffiliateLinkDataProvider supplyGroups={recipe.supplyGroups}>
      {({ supplyGroups }) => (
        <div className="RecipeFirstRecipe">
          <div className="RecipeFirstRecipe__leftColumn">
            {!ingredientGroups || !ingredientGroups.length ? null : (
              <section className="RecipeFirstRecipe__ingredientsSection">
                <h3 className="RecipeFirstRecipe__ingredientsHeading">
                  Ingredients
                </h3>
                <RecipeIngredients groups={ingredientGroups} />

                {ingredientsAddOn && (
                  <div className="RecipeFirstRecipe__ingredientsAddOn">
                    {ingredientsAddOn}
                  </div>
                )}
              </section>
            )}
            {!supplyGroups || !supplyGroups.length ? null : (
              <section className="RecipeFirstRecipe__suppliesSection">
                <RecipeSupplies groups={supplyGroups} />
              </section>
            )}
          </div>
          <div
            className="RecipeFirstRecipe__rightColumn"
            style={
              rightColumnHeight !== undefined
                ? { height: rightColumnHeight }
                : {}
            }
          >
            <h3 className="RecipeFirstRecipe__instructionsHeading">Recipe</h3>
            <RecipeInstructions groups={instructionGroups} isAmp={false} />
            {notes && (
              <section className="RecipeFirstRecipe__notesSection">
                <h3 className="RecipeFirstRecipe__notesHeading">
                  Recipe Notes
                </h3>
                <div
                  className="RecipeFirstRecipe__notes"
                  dangerouslySetInnerHTML={{ __html: notes }}
                />
              </section>
            )}
          </div>
          {rightColumnHeight !== undefined ? (
            <div className="expandRecipeButton">
              <button
                onClick={() => {
                  setRightColumnHeight(undefined);
                }}
              >
                Expand Recipe
              </button>
            </div>
          ) : null}
          <style jsx>{styles}</style>
        </div>
      )}
    </RecipeSupplyAffiliateLinkDataProvider>
  );
}

RecipeFirstRecipe.defaultProps = {};

RecipeFirstRecipe.propTypes = {
  recipe: shape({
    ingredientGroups: arrayOf(
      shape({
        // TBD
      })
    ),
    instructionGroups: arrayOf(
      shape({
        // TBD
      })
    ),
    notes: string,
    supplyGroups: arrayOf(
      shape({
        // TBD
      })
    ).isRequired
  }).isRequired,
  post: shape({
    isSponsored: bool.isRequired,
    canonical: string.isRequired
  }).isRequired
};

export default RecipeFirstRecipe;
